/**
 * Provenance-carrying data shape.
 *
 * Every reference value in src/data is wrapped in a Datum so that:
 *  - a finding can cite where its expectation came from
 *  - the UI can show how much to trust it
 *  - scripts/validate-data.ts can reject unprovenanced data at build time
 */
export type Confidence = 'low' | 'medium' | 'high';

export interface Datum<T> {
  value: T;
  /** Must be a well-formed URL. Enforced by validate:data. */
  source: string;
  confidence: Confidence;
  note?: string;
  /** ISO date the expectation was last confirmed, when known. */
  verified?: string;
}

export function datum<T>(
  value: T,
  source: string,
  confidence: Confidence,
  extra?: { note?: string; verified?: string },
): Datum<T> {
  return { value, source, confidence, ...(extra ?? {}) };
}
